import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-conoce-tu-boleta',
  templateUrl: './conoce-tu-boleta.component.html',
  styleUrls: ['./conoce-tu-boleta.component.scss']
})
export class ConoceBoletaElectronicaComponent implements OnInit {
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private titleService: Title,
    private metaService:Meta,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Conoce tu boleta | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Porque queremos que nuestros clientes estén informados, te presentamos los aspectos más importantes de tu boleta de gas natural.' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }

      $("#showPanel").click(function () {
        $("#panel").fadeIn("slow");
      });

      $("#hidePanel").click(function () {
        $("#panel").fadeOut("slow");
      });

      $("#showPanel2").click(function () {
        $("#panel2").fadeIn("slow");
      });

      $("#hidePanel2").click(function () {
        $("#panel2").fadeOut("slow");
      });

      $("#showPanel3").click(function () {
        $("#panel3").fadeIn("slow");
      });

      $("#hidePanel3").click(function () {
        $("#panel3").fadeOut("slow");
      });

      $("#showPanel4").click(function () {
        $("#panel4").fadeIn("slow");
      });

      $("#hidePanel4").click(function () {
        $("#panel4").fadeOut("slow");
      });

      $("#showPanel5").click(function () {
        $("#panel5").fadeIn("slow");
      });

      $("#hidePanel5").click(function () {
        $("#panel5").fadeOut("slow");
      });

      $("#showPanel6").click(function () {
        $("#panel6").fadeIn("slow");
      });

      $("#hidePanel6").click(function () {
        $("#panel6").fadeOut("slow");
      });

      $("#showPanel7").click(function () {
        $("#panel7").fadeIn("slow");
      });

      $("#hidePanel7").click(function () {
        $("#panel7").fadeOut("slow");
      });
    }
  }
}
